import { InstructionLevel } from "@/types";
import { Vue } from "vue-class-component";
import Store from "../../store";
import { AuthApi, Role } from "../../autogen";
export default class FormMixin extends Vue {
  protected readonly storeInstance = Store.getInstance();
  globalErrors: { message: string }[] = [];
  formName = "";
  submissionMessage = "";
  /** ボタンダブルクリック防止フラグ */
  processing? = false;
  protected multiSelectBaseOptions = {
    mode: "tags",
    value: [],
    label: "name",
    trackBy: "name",
    valueProp: "id",
    closeOnSelect: false,
    searchable: true,
    createOption: false,
    minChars: 2,
    delay: 0
  };
  protected roles: { name: string; value: string }[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmissionError(err: any) {
    if (err.response) {
      this.globalErrors = [];
      const data = err.response.data;
      if (data.detail) {
        if (Array.isArray(data.detail)) {
          for (const e of data.detail) {
            this.globalErrors.push({
              message: e
            });
          }
        } else {
          this.globalErrors = [{ message: data.detail }];
        }
      } else if (data.message) {
        this.globalErrors = [{ message: data.message }];
      }
    } else if (Array.isArray(err)) {
      this.globalErrors = err;
    } else if (typeof err.response === "undefined") {
      this.globalErrors = [{ message: "サーバーと通信出来ません。暫く経ってから再度お試しください。" }];
    } else {
      this.globalErrors = [{ message: err.message }];
    }
  }
  beforeMount() {
    this.storeInstance.setInstructionContent(InstructionLevel.None, "");
  }
  /**
   * 更新した旨を伝えるダイアログを表示する
   */
  async onSubmit(fn: () => Promise<void>) {
    this.processing = true;
    try {
      await fn()
        .then(() => {
          this.storeInstance.setInstructionContent(
            InstructionLevel.Info,
            `${
              this.submissionMessage ? this.submissionMessage : this.formName ? this.formName + "を更新しました" : "更新しました"
            }`
          );
        })
        .catch(err => {
          throw err;
        });
    } catch (err) {
      console.error(err);
      this.handleSubmissionError(err);
    }
    this.processing = false;
  }
  /**
   * 削除した旨を伝えるダイアログを表示する
   */
  async onDelete(fn: () => Promise<void>, message?: string | string[]) {
    this.storeInstance.setInstructionContent(
      InstructionLevel.Confirm,
      message || `${this.formName}を削除します。よろしいでしょうか？`,
      async () => {
        try {
          await fn();
          this.$emit("submitted");
          this.storeInstance.setInstructionContent(InstructionLevel.Info, `${this.formName}の削除が完了しました`);
        } catch (err) {
          console.error(err);
          this.handleSubmissionError(err);
        }
      }
    );
  }
  protected async setRoles() {
    const roles = (await new AuthApi().getRoles({})).data;
    const initialRole = parseInt(this.storeInstance.getRole().id!) === 1 ? [{ name: "システム管理者", value: "1" }] : [];
    // @ts-ignore
    this.roles = roles.reduce((p: typeof this.roles, c: Role) => {
      const { name, id } = c;
      p.push({ name, value: id });
      return p;
    }, initialRole);
  }
}
